export const transformContactByRelationId = (children) => Object.fromEntries(children.flatMap(({ relations }) => relations.map(({ relationId, personKey, role, lastNameInitial, hasImage }) => [
    relationId,
    {
        personKey: personKey !== null && personKey !== void 0 ? personKey : null,
        role: role !== null && role !== void 0 ? role : null,
        lastNameInitial: lastNameInitial !== null && lastNameInitial !== void 0 ? lastNameInitial : null,
        hasImage: hasImage !== null && hasImage !== void 0 ? hasImage : true,
    },
])));
